/* tslint:disable */
/* eslint-disable */
/**
 * SR AAT specification
 * Description
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SearchProductsRequest
 */
export interface SearchProductsRequest {
    /**
     * 
     * @type {string}
     * @memberof SearchProductsRequest
     */
    pattern: string;
}

/**
 * Check if a given object implements the SearchProductsRequest interface.
 */
export function instanceOfSearchProductsRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "pattern" in value;

    return isInstance;
}

export function SearchProductsRequestFromJSON(json: any): SearchProductsRequest {
    return SearchProductsRequestFromJSONTyped(json, false);
}

export function SearchProductsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchProductsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'pattern': json['pattern'],
    };
}

export function SearchProductsRequestToJSON(value?: SearchProductsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'pattern': value.pattern,
    };
}

